import EventBus from "./index.js"
const eventbus = new EventBus()
export default eventbus
